import { Component, OnInit } from '@angular/core';
import { CartService } from '../commons/cart.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfigService } from '../commons/config.service';

declare var _gaq: any;
declare var ga: any;
declare var fbq: Function;
declare var gtag: any;

@Component({
  selector: 'order-completed',
  template: require('./order-completed.component.html'),
})

export class OrderCompletedComponent implements OnInit {

  public OldTotalCart: number;

  public ecomm_prodids = '';
  public ecomm_value = 0;

  constructor(
    public cartService: CartService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public config: ConfigService
  ) {

  }

  ngOnInit() {
    $('#loaderApp').hide();

    let value = this.cartService.cart.totalALLPriceStatic;

    if (value && !isNaN(value)) {
      this.OldTotalCart = parseFloat(value.toFixed(2));
    } else {
      this.OldTotalCart = 0;
    }

    //console.log('this.OldTotalCart: ' + this.OldTotalCart);

    // if (this.OldTotalCart === 0) {
    //   this.router.navigate(['/']);
    // } else
    {
      this.cartService.cart.cartProducts.forEach(prod => {
        this.ecomm_prodids += '\'' + prod.idProduct + '\',';
        this.ecomm_value += prod.totalPriceStatic;
        //console.log(prod);
      });
      this.ecomm_prodids = this.ecomm_prodids.substring(0, this.ecomm_prodids.length - 1);
      //console.log('ecomm_prodid: ' + this.ecomm_prodids + ' - this.ecomm_value: ' + this.ecomm_value);


      let idTransaction = 0;
      this.activatedRoute.params.subscribe((params: Params) => {
        idTransaction = params['idTransaction'] as number;
      });

      if (idTransaction !== 0) {

        // FACEBOOK ECOMMERCE
        fbq('track', 'Purchase', {
          content_ids: [this.ecomm_prodids],
          content_type: 'product',
          value: this.ecomm_value,
          currency: 'EUR'
        });


        // ANALYTICS ECOMMERCE
        ga('require', 'ecommerce', 'ecommerce.js');
        ga('ecommerce:addTransaction', {
          'id': idTransaction,
          'affiliation': 'Topcolor - Order',
          'revenue': this.cartService.cart.totalALLPriceStatic,
          'shipping': this.cartService.cart.delivPrice,
          'tax': this.cartService.cart.totalALLPriceStatic - (this.cartService.cart.totalALLPriceStatic / 1.22)
        });
        ga('ecommerce:send');


        // SVUOTO IL CARRELLO DAI PRODOTTI MANTENDO LE ALTRE INFO
        this.cartService.cart.cartProducts = this.cartService.cart.cartProducts.filter(r => r.idRow === 999999);
        this.cartService.cart.TOTALCartORDER = 0;
        this.cartService.cart.totalALLPriceStatic = 0;
        this.cartService.saveCart();
        this.cartService.cartCheckProducts(false);
        //console.log('carrello svuotato');
      }
    }

    // Event snippet for Ordine Completato conversion page
    gtag('event', 'conversion', {
      'send_to': 'AW-851653320/tDADCN6TxHEQyOWMlgM',
      'value': 1.0,
      'currency': 'EUR'
    });
    //console.log('conversione adwords AW-851653320');

  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/order-completed.component.ts